import { getMapStyles, mapStylesToGetParameters, APIKEY, markerIcon } from './maps-utilities';

const maps = {};

/**
 * Set markers and centerize map
 * @param {HTMLElement} mapElement mapElement object
 */
function setMarkersAndCenter(mapElement) {
  var map = maps[mapElement.id];
  var bounds = new window.google.maps.LatLngBounds();

  if (map.markers) {
    map.markers.forEach( marker => {
      marker.setMap(null);
    });
  }

  map.markers = [];

  if (map.markerData && map.markerData.length > 0) {

    map.markerData.forEach( marker => {
      const latlng = new window.google.maps.LatLng(marker.lat, marker.lon);
      const gMarker = new window.google.maps.Marker({
        position: latlng,
        map: map.map,
        icon: markerIcon,
      });

      map.markers.push(gMarker); //reference to maps[id].markers.marker

      bounds.extend(latlng);
    })
  } else {
    var latlng = new window.google.maps.LatLng(60.169845, 24.938551); //show helsinki as default if there are no markers
    bounds.extend(latlng);
  }

  map.map.fitBounds(bounds);
}

/**
 * Initialize dynamic Google Map element
 * @param {HTMLElement} mapElement HTMLElement wrapped to jQuery object
 */
function initializeDynamicMap(mapElement) {
  const id = mapElement.id;

  maps[id] = {};
  maps[id].markerData = [];

  if (mapElement.dataset.coords !== '') {
    maps[mapElement.id].markerData.push({
      lat: mapElement.dataset.coords.split(';')[0],
      lon: mapElement.dataset.coords.split(';')[1],
    });
  }

  maps[mapElement.id].map = new window.google.maps.Map(mapElement, getMapStyles());
  setMarkersAndCenter(mapElement);
}


/**
 * Initializes store page static maps
 */
function initStaticMaps() {
  const mapStyles = getMapStyles();

  document.querySelectorAll('.static-map').forEach(staticMapElement => {
    const coordinates = staticMapElement.dataset.coords;
    const parameters = mapStylesToGetParameters(mapStyles);

    const [latitude, longitude] = coordinates.split(';');

    const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';

    //Static map's size limit is 640px in all directions, might be a problem in some screen sizes :|
    //Store pages map is sized dynamically based on the store's image
    const size = `?size=${640}x${640}`;
    const markers = `&markers=icon:${markerIcon}|${latitude},${longitude}`;
    const center = `&center=${latitude},${longitude}`;

    const url = `${baseUrl}${size}${center}&style=${parameters}${markers}&zoom=12&key=${APIKEY}&scale=2`;

    const imageElement = document.createElement('img');
    imageElement.src = url;
    imageElement.alt = 'Location map';

    //After user click static map a dynamic map is loaded
    imageElement.addEventListener('click', () => {
      staticMapElement.classList.add('hidden');
      const dynamicMapElement = document.querySelector('.dynamic-map');
      dynamicMapElement.classList.remove('hidden');
      initializeDynamicMap(dynamicMapElement);

      dynamicMapElement.style.position = 'absolute';
      dynamicMapElement.style.width = '100%';
      dynamicMapElement.style.height = '100%';
    });

    staticMapElement.appendChild(imageElement);
  });
}

/**
 * Global callback that is called by Google Map API callback function.
 */
window.mapApiLoaded = function() {
  document.querySelectorAll('.map-canvas').forEach(mapElement => {
    initializeDynamicMap(mapElement);
  });

  initStaticMaps();
};

/**
 * Inject external Javascript script to DOM. This is ment to replace $.getSscript() method used before this.
 *
 * @param {string} script script name
 */
function injectScript(script) {
  const scriptTag = document.createElement('script');
  scriptTag.src = script; // set the source of the script to your script
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag); // append the script to the DOM
}

export default {
  init: function() {
    const hasStaticMaps = document.querySelectorAll('.static-map').length > 0;

    if (document.body.classList.contains('google-map') || hasStaticMaps) {
      //When this script is fully loaded GoogleMaps calls window.mapApiLoaded callback.
      injectScript(`https://maps.googleapis.com/maps/api/js?key=${APIKEY}&libraries=geometry&sensor=true&async=2&callback=mapApiLoaded`);
    }
  }
};
